import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Copy, Check, Send } from 'lucide-react';
import PageTransition from '../components/common/PageTransition';
import SEOHead from '../components/common/SEOHead';
import SectionHeader from '../components/common/SectionHeader';

const Contact: React.FC = () => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const email = "Kynothancontact@gmail.com";

  const handleCopy = () => {
    navigator.clipboard.writeText(email);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  return (
    <PageTransition>
      <SEOHead title={t('nav.contact')} />
      <div className="space-y-12 max-w-lg mx-auto">
        <SectionHeader
          title={t('contact.title')}
          description={t('contact.subtitle')}
          iconName="Mail"
          badge={t('nav.contact')}
        />

        {/* Email Card — single centered block */}
        <div className="art-card p-8 md:p-10 rounded-3xl border-brand-indigo/30 bg-white/50 dark:bg-slate-900/50 space-y-6 text-center">
          <div className="space-y-3">
            <span className="text-xs uppercase tracking-widest font-bold text-brand-indigo">
              {t('contact.emailBox.title')}
            </span>
            <div className="font-mono text-base sm:text-lg font-bold text-slate-800 dark:text-white bg-black/5 dark:bg-white/5 p-4 rounded-xl border border-black/10 dark:border-white/10 break-all select-all">
              {email}
            </div>
          </div>

          <div className="space-y-3">
            <button
              onClick={handleCopy}
              className={`w-full inline-flex items-center justify-center gap-2 px-4 py-3.5 rounded-xl font-bold text-sm transition-all ${
                copied
                  ? "bg-emerald-500 text-white shadow-lg shadow-emerald-500/20"
                  : "bg-brand-indigo hover:bg-indigo-500 text-white shadow-lg shadow-brand-indigo/20"
              }`}
            >
              {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
              <span>{copied ? t('contact.emailBox.copied') : t('contact.emailBox.copy')}</span>
            </button>

            <a
              href={`mailto:${email}`}
              className="w-full inline-flex items-center justify-center gap-2 px-4 py-3.5 rounded-xl bg-black/5 hover:bg-black/10 dark:bg-white/5 dark:hover:bg-white/10 text-slate-700 dark:text-slate-200 font-semibold text-sm transition-all"
            >
              <Send className="w-4 h-4" />
              <span>{t('contact.emailBox.send')}</span>
            </a>
          </div>
        </div>
      </div>
    </PageTransition>
  );
};

export default Contact;
